import { ApolloError } from "@apollo/client";
import * as Sentry from "@sentry/browser";
import { notification } from "antd";
import i18n from "config/i18n/i18n";

export function onErrorGraphql(error: ApolloError): void {
  const { message, networkError } = error;
  const statusCode = (networkError as { statusCode?: number } | null)?.statusCode;

  if (statusCode === 401 || statusCode === 403) return;

  Sentry.captureException(new Error(message));

  notification.error({
    message: i18n.t("Unexpected error", { ns: "newraiANTDPackage" }),
    description: i18n.t(
      "An unexpected error occurred processing your request, please try again later.",
    ),
    placement: "bottomRight",
  });
}
